import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_LEADERS } from '../../graphql/query/leaderBoard/leaders.query';
import {
  GetLeadersQuery,
  LeaderBoardCategories,
  leaderBoardFields
} from '../../types/leaderboard/leaderboard';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import FrontError from '../../helpers/errors/front.error';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { TabLeaderboardNav } from '../../components/molecules/Nav/TabLeaderboardNav';
import { FeatureHighScore } from '../../components/organisms/Dashboard/FeatureHighScore';
import { useMediaQuery } from '../../hooks/useMediaQuery';

const LeaderBoards = () => {
  const isDeviceIsUnderLaptop = useMediaQuery('laptop');

  const [selectedBoard, setSelectedBoard] = React.useState<
    LeaderBoardCategories
  >('classe');

  const [getclassement, { loading, data, error }] = useLazyQuery<
    GetLeadersQuery,
    { tableau: LeaderBoardCategories }
  >(GET_LEADERS);

  useEffect(() => {
    selectedBoard === 'classe' &&
      getclassement({ variables: { tableau: 'classe' } });
    if (selectedBoard === 'academie')
      getclassement({ variables: { tableau: 'academie' } });
    if (selectedBoard === 'niveau')
      getclassement({ variables: { tableau: 'niveau' } });
    if (selectedBoard === 'national') getclassement();
  }, [selectedBoard, getclassement]);

  return (
    <div style={{ paddingTop: `${isDeviceIsUnderLaptop ? '0px' : '50px'}` }}>
      {loading ? (
        <>
          {isDeviceIsUnderLaptop && (
            <HeaderText text="Les Classements" emoji={emojis['BarChart']} />
          )}
          <TabLeaderboardNav
            selected={selectedBoard}
            setSelected={setSelectedBoard}
          />
          <LoadingContainer status={true} />
        </>
      ) : error ? (
        <ErrorContainer
          text={
            'Informations de classe non valide, veuillez recharger la page ou vous déconnecter puis reconnecter'
          }
          setFeedback
          detailErr={
            new FrontError('Dashboard, erreur récupération eleve', error)
          }
          needCaptureError={false}
        />
      ) : (
        <>
          {isDeviceIsUnderLaptop && (
            <HeaderText text="Les Classements" emoji={emojis['BarChart']} />
          )}
          <TabLeaderboardNav
            selected={selectedBoard}
            setSelected={setSelectedBoard}
          />
          {selectedBoard === 'national' && data?.getClassement && (
            <FeatureHighScore
              users={data.getClassement}
              img={leaderBoardFields.national.img}
              type="national"
            />
          )}
          {selectedBoard !== 'national' && data && (
            <FeatureHighScore
              users={data.getClassement}
              img={leaderBoardFields[selectedBoard].img}
              type={selectedBoard}
            />
          )}
        </>
      )}
    </div>
  );
};
export default LeaderBoards;
